import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { productListColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { publicImageProps } from "../../services/config";
import ProductFilter from "./ProductFilter";
import { digitsThree } from "../../utils/price";
import DefaultImage from "../../components/common/default-image/DefaultImage";
import { convertDate } from "../../utils/convertDate";

export default function ProductList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [productData, setProductData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const getProduct = async (params) => {
    const path = "admin/products";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setProductData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getProduct({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getProduct(allFilter);
  };

  const data = [];

  productData?.map((item) => {
    const showDiscountPercent = item.option?.variations?.find(
      (i) => i.discountPercent
    )
      ? "آپشن تخفیف دارد"
      : `${item.discountPercent}%`;
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      basePrice: `${digitsThree(item.basePrice)}`,
      showCategories: item?.categories?.length
        ? item?.categories.map((item) => {
            return <span className="text-xs">{item.name} ،</span>;
          })
        : null,
      discountExpireDate: item.discountExpireDate
        ? convertDate(item.discountExpireDate,true)
        : null,
      showDiscountPercent: showDiscountPercent,
      faInventoryStatus:
        item.inventoryStatus == "available" ? "موجود" : "نا موجود",
      showMainImage: item.mainImage ? (
        <img
          className="w-10 h-10 rounded-md"
          {...publicImageProps(item.mainImage, { variant: "thumb_" })}
        />
      ) : (
        <DefaultImage imgSize={26} imgClass={"!w-10 !h-10 rounded-md"} />
      ),
      createdAt: item.createdAt,
      faStatus:
        (item.status === "active"
          ? "فعال"
          : item.status === "pending"
          ? "انتظار"
          : "غیرفعال") || "pending",
    });
  });

  const navigate = useNavigate();

  const editProduct = (singleProduct) => {
    const newSingleProduct = productData.filter((item) => {
      return item._id == singleProduct.id;
    });
    navigate("/edit-product", { state: newSingleProduct[0] });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست محصولات"} />
      <ProductFilter filterDataHandler={filterDataHandler} />
      <Pagination
        filterDataHandler={filterDataHandler}
        pagination={pagination}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry} columns={productListColumns} rows={data} onEdit={editProduct} />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
